var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.861 9.568v-.126c.003-.588.058-1.056.166-1.403.11-.347.266-.627.467-.838a3.59 3.59 0 01.736-.589c.198-.123.374-.258.53-.404.16-.15.284-.315.375-.497.091-.185.137-.391.137-.618 0-.257-.06-.48-.18-.668a1.223 1.223 0 00-.487-.438 1.454 1.454 0 00-.677-.156c-.231 0-.45.05-.658.151a1.275 1.275 0 00-.511.448c-.133.198-.208.45-.224.755H4.8c.016-.617.166-1.133.448-1.549a2.65 2.65 0 011.13-.935c.47-.207.99-.311 1.558-.311.62 0 1.166.108 1.637.326.474.217.842.528 1.105.93.266.4.4.873.4 1.422 0 .37-.06.701-.18.994a2.411 2.411 0 01-.502.779 3.67 3.67 0 01-.775.609 3.304 3.304 0 00-.647.506 1.683 1.683 0 00-.37.619 2.857 2.857 0 00-.122.867v.126H6.86zm.847 3.04c-.292 0-.543-.105-.754-.313a1.026 1.026 0 01-.317-.76c0-.292.105-.542.317-.75.21-.207.462-.311.754-.311.29 0 .54.104.75.312.215.207.322.457.322.75 0 .198-.05.378-.151.54a1.12 1.12 0 01-.39.39c-.159.094-.336.141-.53.141z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d195191aa54ee8587c91f80e00249582.svg";
export { ForwardRef as ReactComponent };